'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/CalendarBlank.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(p, { ref: r, ...o, weights: e$1 }));
e.displayName = "CalendarBlankIcon";
const c = e;
export {
  c as CalendarBlank,
  e as CalendarBlankIcon
};
